import type { FC } from 'react';
import { lazy } from 'react';
import {
  JOB_RUN_SEARCH_URL,
  useJobRunSearch,
} from 'src/apis/transparency-reporting/use-job-run-search';
import { useReportsPageParams } from 'src/pages/reporting/transparency-reporting/reports/overview/use-page-params';

const Page = lazy(() => import('./page'));

export const ReportsOverview: FC = () => {
  const pageParams = useReportsPageParams();
  const search = useJobRunSearch({
    jobRunSearchUrl: JOB_RUN_SEARCH_URL,
    params: pageParams.value,
  });

  return <Page pageParams={pageParams} search={search} />;
};
